import React, { useEffect, useState } from "react";
import "./EventCoordinatorListing.css";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllCoordinators } from "../../context/Slice/CoordinatorManagementSlice";

import { CreateEvent } from "../../context/Slice/EventManagementSlice";
import {
  FaUser,
  FaLanguage,
  FaTransgender,
  FaCheckCircle,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode"; // Corrected import
import ModalBooking from "../Common/ModalBooking/ModalBooking.js";
import axios from "axios";

const EventCoordinatorListing = () => {
  const dispatch = useDispatch();

  // Redux data
  const AllEventCoordinator = useSelector(
    (state) => state.CoordinatorManagementR?.Data?.ShowCoordinatorProfile || []
  );
  console.log(AllEventCoordinator);

  const [email, setEmail] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const location = useLocation();
  const formDetails = location.state?.formDetails || {};
  const [userId, setUserId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [corId, setCorId] = useState(null);
  const [coordinatorData, setcoordinatorData] = useState([]);

  const token = secureLocalStorage.getItem("token");

  useEffect(() => {
    async function fetchcoordinatorData() {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/User/ShowAll-users?role=co-ordinator`
        );
        console.log(response.data.data.coordinatorRole);
        setcoordinatorData(response.data.data.coordinatorRole);
      } catch (error) {
        console.log(error);
      }
    }
    fetchcoordinatorData();
  }, []);

  // Decode token and fetch data
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        // console.log("Decoded Token:", decoded);
        setUserId(decoded._id);
        setEmail(decoded.email);

        if (formDetails) {
          dispatch(
            ShowAllCoordinators({
              city: formDetails.Event_preferences_locations,
              Language: formDetails.preferences_Language,
            })
          )
            .unwrap()
            .then((response) => {
              console.log("ShowAllCoordinators API Response:", response);
            })
            .catch((error) => {
              console.error("ShowAllCoordinators API Error:", error);
            });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [dispatch, token, formDetails]);

  console.log(formDetails)

  const updatedCoordinators =
    AllEventCoordinator?.map((coordinator) => {
      // ✅ Find the corresponding stored coordinator by ID
      const storedData = coordinatorData?.find(
        (stored) => stored.id.toString() === coordinator.UserID.toString() // ✅ Ensure matching type
      );

      console.log("Stored Data for Coordinator:", storedData); // Debugging check

      return {
        ...coordinator,
        role_type: storedData?.role_type, // ✅ No "N/A", since data exists
      };
    }) || [];
  console.log(updatedCoordinators);

  const updatedByRole = updatedCoordinators?.filter(
    (data) => data.role_type === "Employee" ? data.number_of_events <= 5 : true
  );

  // First, filter employees with `no_of_events < 5`
  let filteredData = updatedByRole?.filter(
    (data) => data.role_type === "Employee" && data.number_of_events <= 5
  );

  // If no employees are left, fallback to Masters
  if (filteredData.length === 0) {
    filteredData = updatedByRole?.filter((data) => data.role_type === "Master");
  }

  console.log("Filtered Coordinators:", filteredData);

  // Get image path
  const getImagePath = (imageData) => {
    if (!imageData || imageData === "[]" || imageData === "null") {
      return "assets/dummyProfile.jpg";
    }
    try {
      const images = JSON.parse(imageData);
      if (images && images.length > 0) {
        return `${BASE_URL}/uploads/${images[0].filename}`;
      }
    } catch (error) {
      console.error("Error parsing coordinator image:", error);
    }
    return "assets/dummyProfile.jpg";
  };

  // Handle coordinator selection
  const selectCoordinator = (coordinatorId) => {
    if (userId && formDetails && email) {
      const updatedData = {
        ...formDetails,
        User_id: userId,
        Coordinator_id: coordinatorId,
        email: email,
      };

      console.log("Updated Data for CreateEvent:", updatedData);
      dispatch(CreateEvent(updatedData))
        .unwrap()
        .then((response) => {
          console.log("CreateEvent API Response:", response);
        })
        .catch((error) => {
          console.error("CreateEvent API Error:", error);
        });
    } else {
      console.error("User ID, formDetails, or email not found.");
    }
  };

  return (
    <div id="EventCoordinatorListing">
      {openModal && <ModalBooking closeModal={setOpenModal} cor_id={corId}  />}
      <div className="row align-items-center">
        <div className="centered-container card-container-heading">
          <h2 className="section-heading">
            This is Your Event Coordinator For Your Day
          </h2>
          <p className="section-para text-border">
            "Most Experienced Event Coordinators"
          </p>
        </div>
      </div>

      <div className="container profile-page">
        <div className="row card-container">
          {/* Ensure data is mapped correctly */}
          {filteredData?.length > 0 ? (
            filteredData?.map((coordinator, index) => {
              // console.log("Mapping coordinator:", coordinator);
              return (
                <div
                  className="col-xl-6 col-lg-7 col-md-12"
                  key={coordinator.UserID || index}
                >
                  <div className="card profile-header">
                    <div className="body">
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-12">
                          <div className="profile-image float-md-right mt-3">
                            <img
                              src={getImagePath(coordinator.CoordinatorsImage)}
                              alt={`${coordinator.firstName} ${coordinator.lastName}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "assets/dummyProfile.jpg";
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-12">
                          <p>
                            <FaUser className="me-2" />
                            <strong>Full Name:</strong> {coordinator.firstName}{" "}
                            {coordinator.lastName}
                          </p>
                          <p>
                            <FaLanguage className="me-2" />
                            <strong>Languages: </strong> {JSON.parse(coordinator.Languages).join(", ")}
                          </p>

                          <p>
                            <FaTransgender className="me-2" />
                            <strong>Gender:</strong> {coordinator.Gender}
                          </p>
                          <div>
                            <button
                              className="btn btn-primary btn-round w-50"
                              onClick={() => {
                                console.log(coordinator.UserID)
                                selectCoordinator(coordinator.UserID);
                                setOpenModal(true);
                                setCorId(coordinator.UserID);
                              }}
                            >
                              <FaCheckCircle className="me-2 fs-3 mt-2" /> Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No coordinators available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventCoordinatorListing;
